import React, { useContext, useEffect, useMemo, useState } from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import { useNavigate } from "react-router-dom";
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { AppContext } from '../../store/contexts/AppContext.js';
import { NavigationContext } from '../../store/contexts/NavigationContext.js';
import { NewsAndStories, Showroom, Signpost, VideoBanner, VideoHero, NextStepsSection } from '../../components';
import { AtmosphereBanner } from '../../partials';
import { lbxOrder } from '../../helpers/showroom';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function StandardScreen(props) {
    
    const navigate = useNavigate();
    const { labels, customerProfile, settings, guestPromptRendered } = props;
    const { setSelectedAtmosphere, selectedAtmosphere } = useContext(AppContext);
    const { navigateToActions } = useContext(NavigationContext);
    const { navigateToAiExperience, navigateToInspirationAndGallery, navigateToStyleSelector } = navigateToActions
    const { 
        showVideoBanner, 
        showShowroom, 
        showReservePrompts,
        showStyleSelectorPrompt,
        showNewsAndStories,
        showNextSteps,
        showAiSignPosting,
        show360ExperienceLinks  
    } = settings;
    
    const firstName = _get(customerProfile, 'firstName', '');
    const heroLabels = _get(labels, 'personalised-hero', {});
    const newsAndStoriesLabels = _get(labels, 'news-and-stories', {});
    const showroomLabels = _get(labels, 'showroom', {});
    const stylePromptLabels = _get(labels, 'style-selector-prompt', {});
    const aiExperiencePromptLabels = _get(labels, 'ai-experience-prompt', {});
    const videoBannerLabels = _get(labels, 'video-banner.default', {})
    const nextStepsLabels = _.get(labels, 'next-steps', {})
    const isInjected= _get(settings, 'isInjected', false);
    const atmosphere = 'default';
    const showroomItems = _get(showroomLabels, 'items', []);
    const cityEventsLabels = _get(labels, 'city-events', {});
    const [newsAndEvents, setNewsAndEvents] = useState({})
    const block = 'c-customised-screen';
    
    const orderedShowroomItems = useMemo(() => 
        lbxOrder(showroomItems), 
    [showroomItems]);
    
    const startingShowroomIndex = useMemo(() => 
        _.findIndex(orderedShowroomItems, function(i) { return i.name == 'EMOTION';})
    ,[orderedShowroomItems]);
   
    const onClickActions = {
		'navigate-to-style-selector': ()=> { navigate('../style')},
	  }; 

    useEffect(() => {
      fireGTMTrackingEvent({
        name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
        componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxYourExperience, 
        componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
        action: CORE_GTM_TRACKING_VALUES.action.homeScreen,
        label: CORE_GTM_TRACKING_VALUES.label.general
      }, {
        workflow: {
          name: LBX_GTM_TRACKING_VALUES.componentName.lbxYourExperience,
          step: CORE_GTM_TRACKING_VALUES.action.homeScreen,
          conversion: 0,
          variant: CORE_GTM_TRACKING_VALUES.label.general
        }
      });
    }, []);

    useEffect((()=>{
        const content = {};
        const newsAndStoriesItems = _.get(newsAndStoriesLabels, 'carousel.items', []); 
        const cityEventsItems =_.get(cityEventsLabels, 'carousel.items', []);
        const combinedItems = newsAndStoriesItems.concat(cityEventsItems);

        _.set(content, 'intro', newsAndStoriesLabels.intro)
        _.set(content, 'carousel.items', combinedItems)

        setNewsAndEvents(content)

    }), [newsAndStoriesLabels, cityEventsLabels])

    return (
        <div id='personal-page-standard-view' className={classNames({
                [`${block}--blur-background`]:guestPromptRendered
            })}>
            <VideoHero {...{
                ...heroLabels, 
                atmosphere, 
                firstName, 
                showStyleSelectorPrompt, 
                isInjected,
                navigateToStyleSelector 
            }}/>
            {showVideoBanner && 
                <VideoBanner {...{
                    ...videoBannerLabels,
                    settings
                }}/> 
            }
            {showShowroom && 
                <Showroom {...{
                    ...showroomLabels,
                    title: _.get(showroomLabels, 'standard-title', ''), 
                    subtitle:_.get(showroomLabels, 'standard-subtitle', ''),
                    startPosition: 1 + startingShowroomIndex,
                    items:orderedShowroomItems,
                    onCardChange: (atmosphere) => setSelectedAtmosphere(atmosphere),
                    isInfiniteScroll: true,
                    inheritParentTheme: false,
                    selectedAtmosphere,
                    showReservePrompts: !!showReservePrompts,
                    show360ExperienceLinks: !!show360ExperienceLinks
                }}/> 
            }
            {showStyleSelectorPrompt && 
                <AtmosphereBanner {...{
                    ...stylePromptLabels,
                    theme: 'lbx',
                    inheritParentTheme: true,
                    onClickActions
                }}/>
            }
            { showAiSignPosting && 
                <Signpost {...{
                    ...aiExperiencePromptLabels,
                    onClickCallbackSecondary: navigateToInspirationAndGallery
                }}/>
            }
            {showNewsAndStories && 
                <NewsAndStories {...{
                    ...newsAndEvents
                }}/>
            }
            {showNextSteps && 
                <NextStepsSection {...{
                    title: _.get(nextStepsLabels, 'title'), 
                    subtitle: _.get(nextStepsLabels, 'subtitle'), 
                    blocks:_.get(nextStepsLabels, 'blocks', []), 
                    layout:_.get(nextStepsLabels, 'layout','vertical')
                }}/>
            }
        </div>
    )
}